<template>
    <div class="wrap-layer">
        <light-header :back="true"></light-header>

        <div class="set-sign-control auto">
            <div class="desc-wrap" style="margin-bottom: 30px"
                v-if="processStatus === 'pass' || processStatus === 'reject'">
                <el-alert :show-icon="true" :closable="false" title="审批通过！" type="success"
                    v-if="processStatus === 'pass'">
                </el-alert>
                <el-alert :show-icon="true" :closable="false" title="审批驳回！" type="error"
                    v-if="processStatus === 'reject'">
                </el-alert>
            </div>
            <el-descriptions title="审批流程信息" class="desc-wrap" :column="1">
                <el-descriptions-item label="发起人" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.launchUserName }}</el-descriptions-item>
                <el-descriptions-item label="审批类型" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    <el-tag size="small" v-if="flowMainTypeOptions && flowMainTypeOptions.length && descData.flowType">
                        {{ flowMainTypeOptions
                        &&
    flowMainTypeOptions.length ? flowMainTypeOptions.find(item => {
        return item.dictValue ===
            descData.flowType
    }).dictLabel : ""
                        }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="流程名称" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.processName }}</el-descriptions-item>
                <el-descriptions-item label="流程描述" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.processDesc }}
                </el-descriptions-item>
                <el-descriptions-item label="创建时间" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.createTime && descData.createTime.replace(/T|\.\S+/g, " ") }}</el-descriptions-item>
            </el-descriptions>
            <div class="desc-wrap" style="margin-bottom: 25px;margin-top: 20px">
                <div class="el-descriptions__header">
                    <div class="el-descriptions__title">审批人列表</div>
                    <div class="el-descriptions__extra"></div>
                </div>
                <el-table :data="descData.nodeArray" style="width: 100%">
                    <el-table-column label="审批人" align="center" prop="nodeUserName"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="nodeStatus">
                    </el-table-column>
                    <el-table-column label="审批意见" align="center" prop="nodeProcessDesc"></el-table-column>
                    <el-table-column label="审批时间" align="center" prop="nodeProcessTime"></el-table-column>
                </el-table>
            </div>
            <el-descriptions title="合同任务信息" class="desc-wrap" :column="1" style="margin-top: 20px">
                <el-descriptions-item label="发起方" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.taskInfo && descData.taskInfo.initiatorName ? descData.taskInfo.initiatorName : "" }}
                </el-descriptions-item>
                <el-descriptions-item label="任务主题" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.taskInfo && descData.taskInfo.taskName ? descData.taskInfo.taskName : "" }}
                </el-descriptions-item>
                <el-descriptions-item label="发起时间" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.taskInfo && descData.taskInfo.signStartTime ? descData.taskInfo.signStartTime : "" }}
                </el-descriptions-item>
                <el-descriptions-item label="截止时间" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    {{ descData.taskInfo && descData.taskInfo.signExpireTime ? descData.taskInfo.signExpireTime : "" }}
                </el-descriptions-item>
                <el-descriptions-item label="合同文件" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                    <div class="file-list" v-if="descData.taskInfo && descData.taskInfo.signFileInfoArray">
                        <div class="file-item" v-for="(item, idx) in descData.taskInfo.signFileInfoArray"
                            :key="item.fileId">
                            <div class="file-thumb" :class="{ 'is-blank': !item.filePages }">
                                <img :src="item.fileImgArray[0]" alt="" />
                                <div class="file-count">{{ item.filePages }}页</div>
                                <span class="file-actions">
                                    <span class="file-preview">
                                        <i class="el-icon-zoom-in"
                                            @click="item.filePages && handleFilePreview(idx)"></i>
                                    </span>
                                </span>
                            </div>
                            <div class="file-name">{{ item.fileName }}</div>
                        </div>
                    </div>
                    <div class="file-list" v-else></div>
                </el-descriptions-item>

            </el-descriptions>
            <div class="desc-wrap" style="margin-bottom: 25px;margin-top: 20px">
                <div class="el-descriptions__header">
                    <div class="el-descriptions__title">签署人列表</div>
                    <div class="el-descriptions__extra"></div>
                </div>
                <el-table v-if="descData.taskInfo && descData.taskInfo.signUserArray"
                    :data="descData.taskInfo.signUserArray" style="width: 100%">
                    <el-table-column prop="signSequence" label="签署顺序" width="" align="center">
                        <template slot-scope="scope">
                            <span>{{
                                Boolean(scope.row.signSequence) > 0 ? scope.row.signSequence : "无顺序"
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="签署方" align="center">
                        <template slot-scope="scope">
                            <span>{{
                                scope.row.signSubject === "company" ? scope.row.companyName :
                                    scope.row.personName
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="签署状态" align="center" prop="status"></el-table-column>
                    <el-table-column label="签约时间" align="center" prop="signTime"></el-table-column>
                </el-table>
            </div>
            <el-descriptions title="印章申请信息" class="desc-wrap" :column="1" style="margin-top: 20px">
            </el-descriptions>
            <el-card shadow="hover" v-for="(item, idx) in descData.sealInfoArray" :key="idx" style="margin-bottom: 20px;">
                <el-descriptions :column="1">
                    <el-descriptions-item label="印章名称" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                        {{ item && item.sealName ? item.sealName : "" }}
                    </el-descriptions-item>
                    <el-descriptions-item label="印章类型" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                        <el-tag v-if="item && item.sealType">{{ sealTypeOptions &&
                            sealTypeOptions.length ? sealTypeOptions.find(_item => {
                                return _item.dictValue === item.sealType
                            }).dictLabel : ""
                        }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="印章外形" :label-style="{ width: '70px', 'white-space': 'nowrap' }">
                        <img v-if="item && item.sealImg" :src="item.sealImg" alt=""
                            style="max-width: 200px;margin-top: 10px">
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
            <div class="desc-wrap" style="margin-bottom: 30px"
                v-if="from === 'myapproval' && processStatus === 'waitMe'">
                <el-form :model="approveForm" ref="approveForm" :rules="approveFormRules">
                    <el-form-item label="审批操作" prop="nodeProcessDesc">
                        <el-input ref="nodeProcessDescIpt" v-model="approveForm.nodeProcessDesc" type="textarea"
                            :rows="3" placeholder="在此处输入审批意见" style="width: 100%" />
                    </el-form-item>
                </el-form>
                <!-- <el-input required type="textarea" :rows="3" placeholder="在此处输入审批意见" v-model="nodeProcessDesc" style="width: 90%">
					</el-input> -->
            </div>
            <div class="btn-wrap" v-if="from === 'myapproval' && processStatus === 'waitMe'">
                <el-button type="primary" @click="approveApply('pass')" size="big"
                    style="padding-left: 28px;padding-right: 28px">同意</el-button>
                <el-button @click="approveApply('reject')" size="big"
                    style="padding-left: 28px;padding-right: 28px;margin-left: 35px">驳回</el-button>
            </div>
        </div>

        <el-drawer title="" :visible.sync="descOpen" direction="rtl" custom-class="desc-drawer" append-to-body
            :show-close="true" :modal="false" :withHeader="true" size="80%">
            <div>
                <desc-drawer :from="'myLaunch'" :descFileData="descFileData" @changeDescOpen="changeDescOpen">
                </desc-drawer>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import lightHeader from "../../components/lightHeader";
import descDrawer from "./descDrawer";
import { mapState } from "vuex";
import { getProcessInfo, submitCheck } from "@/api/space/approve";

export default {
    components: {
        lightHeader,
        descDrawer,
    },
    data() {
        return {
            flowMainTypeOptions: [],
            sealTypeOptions: [],
            processStatus: "",
            from: "",
            approveForm: {
                nodeProcessDesc: ''
            },
            approveFormRules: {
                nodeProcessDesc: [
                    { required: true, message: '请输入审批意见', trigger: 'change' }
                ]
            },


            pngList: [],
            dialogVisible: false,
            detail: {
                taskName: null,
                signUserArray: [],
            },
            details: [],
            descOpen: false,
            descData: {},
            descFileData: {}
        };
    },
    computed: {
        ...mapState(["userInfo", "companyList", "currentSpace"]),
    },
    watch: {
        descOpen(newV, oldV) {
            if (newV) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        },
    },
    created() {
        this.processStatus = this.$route.query.processStatus;
        this.from = this.$route.query.from;
        this.getDicts('cus_flow_type').then(response => {
            this.flowMainTypeOptions = response.data
        })
        this.getDicts('cus_seal_type').then(response => {
            this.sealTypeOptions = response.data
        })
        this.getProcessInfo();
    },
    mounted() { },
    methods: {
        getProcessInfo() {
            getProcessInfo({
                processId: this.$route.query.processId
            }).then(res => {
                if (res.code != 200) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                    });
                } else {
                    this.descData = res.data;
                }
            })
        },
        approveApply(type) {
            this.$refs['approveForm'].validate(valid => {
                if (valid) {
                    const param = {
                        processId: this.$route.query.processId,
                        nodeStatus: type,
                        nodeProcessDesc: this.approveForm.nodeProcessDesc
                    }
                    submitCheck(param).then(response => {
                        if (response.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: 'warning'
                            })
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: 'success'
                            })
                            this.$router.go(-1);
                        }
                    })
                } else {
                    // this.$refs.approveForm.$el.scrollIntoView({
                    //     behavior: 'smooth', // 平滑过渡
                    //     block: 'start' // 上边框与视窗顶部平齐。默认值
                    // })
                }
            })
        },


        handleFilePreview(idx) {
            this.$nextTick(() => {
                this.descFileData = {
                    signFileInfoArray: [
                        {
                            fileName: this.descData.taskInfo.signFileInfoArray[idx].fileName
                                ? this.descData.taskInfo.signFileInfoArray[idx].fileName
                                : "",
                            fileImgArray: this.descData.taskInfo.signFileInfoArray[idx].fileImgArray,
                        },
                    ],
                };
            });

            this.descOpen = true;
        },
        changeDescOpen(status) {
            this.descOpen = status;
        },
    },
};
</script>
<style lang="scss" scoped>
.set-sign-control {
    margin-top: 30px;
    padding: 30px;
    background: white;
    position: relative;
    z-index: 9;
    overflow-y: auto;

    /deep/ .el-table {

        .el-table__header-wrapper,
        .el-table__fixed-header-wrapper {
            th {
                word-break: break-word;
                background-color: #f8f8f9;
                color: #515a6e;
                height: 40px;
                font-size: 13px;
            }
        }
    }

    /deep/ .el-descriptions__header {
        font-weight: 400;
        padding: 1px 8px;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        border-left: 3px solid #3296fa;

        .el-descriptions__title {
            font-weight: normal;
        }
    }

    /deep/ .el-form-item__label {
        line-height: normal;
        color: #303133;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    /deep/ .file-list {
        min-height: 174px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 13px;
        flex-wrap: wrap;

        .file-item {
            // margin-top: 26px;
            width: 144px;
            // position: relative;
            margin-right: 15px;

            .file-thumb {
                width: 144px;
                height: 144px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #dcdcdc;
                border-radius: 8px;
                position: relative;

                img {
                    width: 80%;
                    height: 80%;
                    object-fit: contain;
                }

                .file-count {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    font-size: 15px;
                    color: #222;
                    text-align: center;
                    width: 100%;
                    padding: 7px 0;
                }

                .file-actions {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    cursor: default;
                    text-align: center;
                    color: #fff;
                    opacity: 0;
                    font-size: 20px;
                    background-color: rgba(0, 0, 0, 0.5);
                    transition: opacity 0.3s;

                    .file-preview {
                        cursor: pointer;
                    }

                    .file-delete {
                        margin-left: 15px;
                        cursor: pointer;
                    }

                    &::after {
                        display: inline-block;
                        content: "";
                        height: 100%;
                        vertical-align: middle;
                    }
                }

                .file-actions:hover {
                    opacity: 1;
                }

                &.is-blank {
                    .file-actions:hover {
                        opacity: 0;
                    }

                    .file-preview {
                        cursor: default !important;
                    }
                }
            }

            .file-name {
                font-size: 13px;
                font-weight: 400;
                color: #666666;
                margin-top: 12px;
                text-align: center;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
            }
        }

        // .file-item + .file-item {
        // 	margin-left: 15px;
        // }
    }
}

.wrap-layer {
    background: #f0f0f5;
    min-height: 100vh;
}

.info-card {
    margin-top: 20px;
    background: #fff;
    padding: 26px 23px;

    .card-head {
        font-weight: 400;
        color: #333333;
        padding: 1px 8px;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        border-left: 3px solid #3296fa;
    }

    .card-row {
        font-size: 14px;
        color: #666666;
        font-weight: 400;
        margin-top: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 13px;

        &.start {
            justify-content: flex-start;

            div {
                margin-right: 20px;
            }
        }

        span {
            margin-left: 33px;
            color: #333;
        }
    }


}

.detail-wrap {
    padding-bottom: 30px;

    &:nth-of-type(1) {
        padding-bottom: 0;
    }
}

.list-card {
    // margin-top: 18px;
    background: #fff;
    padding: 26px 23px;

    .card-head {
        font-weight: 400;
        color: #333333;
        padding: 1px 8px;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        border-left: 3px solid #3296fa;
        margin-bottom: 26px;
    }

    .table-wrap {
        padding: 0 13px;

        .el-table {
            /deep/ .table-head th {
                background: #f9f9ff;

                .cell {
                    color: #000;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
